module.exports = __webpack_public_path__ + "img/2026-02-27d_3.095d98a0.jpg";